<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">401: Access Denied</h1>
          </div><!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">Home</li>
              <li class="breadcrumb-item active">401</li>
            </ol>
          </div><!-- /.col -->
        </div><!-- /.row -->
      </div><!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <section class="content">
      <div class="error-page">
        <h2 class="headline text-warning"> 401</h2>

        <div class="error-content pt-3">
          <h3><i class="fa fa-exclamation-triangle text-warning"></i> Oops! Access denied.</h3>
          <p>
            You are not authorized to access this page.
            Meanwhile, you may <router-link to="/dashboard">return to dashboard</router-link>.
          </p>
        </div>
        <!-- /.error-content -->
      </div>
      <!-- /.error-page -->
    </section>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->
</template>

<script>

import {mapGetters} from 'vuex'

export default {
  name: 'Error401',

  data() {
    return {

    };
  },

  components: {
    
  },

  computed: {
    ...mapGetters(['user']),
  },

  methods: {

  },

  mounted() {
    this.$Progress.start();
    this.$Progress.finish();
  },



}
</script>
